import React, { useState } from "react";
import GenericModal from "./GenericModal";
import { KeyIcon } from "@heroicons/react/24/outline";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import toast from "react-hot-toast";
import { axiosInstance } from "../../lib/axiosInstance";

const OTPVerificationModal = ({ isOpen, onClose, email, onVerificationSuccess }) => {
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);

    const handleOtpChange = (e) => {
        const value = e.target.value.replace(/\D/g, "").slice(0, 6);
        setOtp(value);
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();

        if (otp.length !== 6) {
            toast.error("Please enter a valid 6-digit OTP");
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.post("/customer/verify-signup-otp", {
                email,
                otp,
            });

            if (response.data.success) {
                toast.success("Email verified successfully!");
                onVerificationSuccess();
                onClose();
            } else {
                toast.error(response.data.message || "Invalid OTP");
            }
        } catch (error) {
            toast.error(
                error.response?.data?.message || "Failed to verify OTP. Please try again."
            );
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setOtp("");
        setLoading(false);
        onClose();
    };

    return (
        <GenericModal
            isOpen={isOpen}
            onClose={handleClose}
            title="Verify Your Email"
            size="max-w-md"
        >
            <div className="space-y-4">
                <p className="text-sm text-gray-600">
                    We've sent a 6-digit OTP to <strong>{email}</strong>. Please enter it below to verify your email address.
                </p>

                <form onSubmit={handleVerifyOtp} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Enter OTP
                        </label>
                        <div className="relative">
                            <KeyIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                            <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={otp}
                                onChange={handleOtpChange}
                                className="w-full pl-10 pr-3 py-3 border rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 tracking-widest text-center text-lg font-semibold"
                                placeholder="000000"
                                maxLength={6}
                                disabled={loading}
                                autoFocus
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={loading || otp.length !== 6}
                        className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-blue-700 transition duration-200 flex items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                        {loading ? (
                            <AiOutlineLoading3Quarters className="animate-spin text-xl" />
                        ) : (
                            "Verify Email"
                        )}
                    </button>
                </form>

                <p className="text-xs text-gray-500 text-center">
                    Didn't receive the OTP? Check your spam folder or try again.
                </p>
            </div>
        </GenericModal>
    );
};

export default OTPVerificationModal;
